<div class="ct-modal">

  <div class="ct-modal-loader" *ngIf="loading">
    <span class="auth-spinner" aria-hidden="true"></span>
  </div>

  <!-- Header -->
  <div class="modal-head">
    <div class="title-block">
      <h2>{{ preview ? 'Preview Timesheet' : 'Create Timesheet' }}</h2>
      <span class="sub" *ngIf="!preview">{{ subTitle }}</span>
      <span class="sub" *ngIf="preview">
        <ng-container *ngIf="jobName">{{ jobName }}</ng-container>
        <ng-container *ngIf="jobName && clientName"> &middot; </ng-container>
        <ng-container *ngIf="clientName">{{ clientName }}</ng-container>
        <ng-container *ngIf="(jobName || clientName) && (start_date || end_date)"> &middot; </ng-container>
        <ng-container *ngIf="start_date">{{ start_date | date: 'd MMM' }}</ng-container>
        <ng-container *ngIf="start_date && end_date"> – </ng-container>
        <ng-container *ngIf="end_date">{{ end_date | date: 'd MMM y' }}</ng-container>
      </span>
    </div>
    <button type="button" class="close-btn" (click)="onClose()" title="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body">
    <ng-container *ngIf="!preview">

      <!-- Other Agencies Form -->
      <!-- <form [formGroup]="timesheetForm" *ngIf="timesheetForm && !is31T">
        <div class="selectTimeSheet">
          <label for="selectTimeSheet">Select Assignment</label>
          <mat-select class="datePickerRangeContainer" (selectionChange)="onAssignmentChange()"
            formControlName="assignment_uuid" [disabled]="disableAssignmentSelect"
            [ngClass]="{'invalidField':timesheetForm.controls.assignment_uuid?.errors && timesheetForm.controls.assignment_uuid?.touched}">
            <mat-option *ngFor="let option of assignments" [value]="option.uuid">{{option.job}}
            </mat-option>
          </mat-select>
        </div>

        <div class="formsRow" *ngIf="!start_date || !end_date">
          <ng-container *ngFor="let field of fields?.fields">
            <div class="customField {{field.type}}" *ngIf="field.field_type !== 'static'">
              <label for="customField">{{field.label}} <span *ngIf="field.is_required" class="requiredStar">*</span></label>
              <input *ngIf="field.type === 'text' || field.type === 'number'" type="text" [type]="field.type"
                class="input-form remover" [(ngModel)]="copyableValues[field.label]"
                [ngModelOptions]="{standalone: true}">
              <textarea *ngIf="field.type === 'textarea'" class="input-form" [(ngModel)]="copyableValues[field.label]"
                [ngModelOptions]="{standalone: true}" id="floatingTextarea"></textarea>
              <mat-select *ngIf="field.type === 'dropdown' || field.type === 'single-select'" class="input-form"
                [(ngModel)]="copyableValues[field.label]" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let option of field.values.split(',')" [value]="option">{{option}}
                </mat-option>
              </mat-select>
            </div>
          </ng-container>
        </div>
        <div class="selectTimeSheet">
          <div class="datePickerRangeContainer" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <i class="bi bi-calendar4"></i>
            <mat-date-range-input [rangePicker]="picker"
              [disabled]="!timesheetForm?.value?.assignment_uuid || !copyableFieldsIsValid" [min]="getLimit('min')"
              [max]="getLimit('max')">
              <input matStartDate [ngModelOptions]="{standalone: true}" [(ngModel)]="start_date" placeholder="Start Date">
              <input matEndDate [ngModelOptions]="{standalone: true}" [(ngModel)]="end_date" placeholder="End Date"
                (dateChange)="dateChanged($event)">
            </mat-date-range-input>
          </div>
        </div>
        <div class="timesheetColumn" *ngIf="timesheets.length">
          <swiper [config]="config">
            <div class="swiper-wrapper" [ngClass]="{'spaceEvenly' : timesheets.length <= 2}">
              <div class="swiper-slide" *ngFor="let timesheet of timesheets; let i = index;"
                (click)="selectedSlideDate = timesheet.index"
                [class.slide-active]="selectedSlideDate === timesheet.index">
                <span>{{dataSharedService.getFormatedDate(timesheet.date)}}</span>
                <i class="bi bi-x-circle" *ngIf="selectedSlideDate === timesheet.index"
                  (click)="removeSlide(i, timesheet.index)"></i>
              </div>
            </div>
            <div class="swiper-button swiper-button-next"></div>
            <div class="swiper-button swiper-button-prev"></div>
          </swiper>
        </div>
        <div class="formsRow" *ngIf="(selectedSlideDate || selectedSlideDate === 0) && timesheets.length">
          <ng-container *ngFor="let timesheet of timesheets">
            <ng-container *ngIf="timesheet.index === selectedSlideDate">
              <ng-container *ngFor="let field of fields?.fields">
                <div class="customField {{field.type}}" *ngIf="field.field_type !== 'static'">
                  <label for="customField">{{field.label}} <span *ngIf="field.is_required" class="requiredStar">*</span></label>
                  <div class="fieldAndCopyButton">
                    <input *ngIf="field.type === 'text' || field.type === 'number'" type="text" [type]="field.type"
                      class="input-form remover" [formControlName]="field.label+'_'+timesheet.index"
                      [ngClass]="{'invalidField':timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}">
                    <textarea *ngIf="field.type === 'textarea'" class="input-form"
                      [formControlName]="field.label+'_'+timesheet.index"
                      [ngClass]="{'invalidField':timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}"
                      id="floatingTextarea"></textarea>
                    <mat-select *ngIf="field.type === 'dropdown' || field.type === 'single-select'" class="input-form"
                      [formControlName]="field.label+'_'+timesheet.index"
                      [ngClass]="{'invalidField':timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}">
                      <mat-option *ngFor="let option of field.values.split(',')" [value]="option">{{option}}
                      </mat-option>
                    </mat-select>
                    <div class="copy">
                      <a class="btn btn-neutral btn-sm bt-square ms-1"
                        (click)="copyValues(field.label, field.label+'_'+timesheet.index, timesheet.index)">
                        <i class="bi bi-clipboard-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </form> -->
      <!-- Other Agencies Form -->

      <!-- 31T Form -->
      <ng-container *ngIf="timesheetForm">
        <form [formGroup]="timesheetForm">

          <div class="ct-top-row">
            <div class="field">
              <label>Select Assignment <span class="req">*</span></label>
              <mat-select class="input-form ct-mat-select"
                          (selectionChange)="onAssignmentChange()"
                          formControlName="assignment_uuid"
                          [disabled]="disableAssignmentSelect"
                          panelClass="ct-mat-select-panel"
                          [ngClass]="{'invalidField': timesheetForm.controls.assignment_uuid?.errors && timesheetForm.controls.assignment_uuid?.touched}">
                <mat-option *ngFor="let option of assignments" [value]="option.uuid">{{option.job}}</mat-option>
              </mat-select>
            </div>

            <div class="field">
              <label>Date range <span class="req">*</span></label>
              <div class="daterange" (click)="picker.open()">
                <i class="bi bi-calendar4"></i>
                <mat-datepicker-toggle matSuffix [for]="picker" class="ct-hidden-toggle"></mat-datepicker-toggle>
                <mat-date-range-picker #picker [startAt]="startOfMonth"></mat-date-range-picker>
                <mat-date-range-input [rangePicker]="picker"
                                      [disabled]="!timesheetForm?.value?.assignment_uuid"
                                      [min]="getLimit('min')"
                                      [max]="getLimit('max')">
                  <input matStartDate
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="start_date"
                         placeholder="Start date">
                  <input matEndDate
                         [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="end_date"
                         placeholder="End date"
                         (dateChange)="dateChanged($event)">
                </mat-date-range-input>
              </div>
            </div>
          </div>

          <ng-container *ngIf="(selectedSlideDate || selectedSlideDate === 0) && timesheets.length">
            <div class="day-grid" [style.--field-count]="dynamicFieldCount">

              <!-- Header row -->
              <div class="row-header">
                <div class="cell date-col">Date</div>
                <ng-container *ngFor="let field of fields?.fields">
                  <div class="cell" *ngIf="field.field_type !== 'static'">
                    {{field.label}}<span *ngIf="field.is_required" class="req">*</span>
                  </div>
                </ng-container>
                <div class="cell remove-col"></div>
              </div>

              <!-- Day rows -->
              <div class="day-row" *ngFor="let timesheet of timesheets; let i = index">

                <div class="cell date-cell">
                  <span class="dow">{{ timesheet.date | date: 'EEE' }}</span>
                  <span class="day-num">{{ timesheet.date | date: 'd MMM' }}</span>
                </div>

                <ng-container *ngFor="let field of fields?.fields">
                  <div class="cell field-cell {{field.type}}" *ngIf="field.field_type !== 'static'">

                    <input *ngIf="field.type === 'text' || field.type === 'number'"
                           [type]="field.type"
                           class="cell-input"
                           [formControlName]="field.label+'_'+timesheet.index"
                           [ngClass]="{'invalidField': timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}">

                    <textarea *ngIf="field.type === 'textarea'"
                              class="cell-input cell-textarea"
                              [formControlName]="field.label+'_'+timesheet.index"
                              [ngClass]="{'invalidField': timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}"></textarea>

                    <mat-select *ngIf="field.type === 'dropdown' || field.type === 'single-select'"
                                class="cell-input cell-select"
                                [formControlName]="field.label+'_'+timesheet.index"
                                panelClass="ct-mat-select-panel"
                                [ngClass]="{'invalidField': timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}">
                      <mat-option *ngFor="let option of field.values.split(',')" [value]="option">{{option}}</mat-option>
                    </mat-select>

                    <input *ngIf="field.type === 'time_range' && field.label === 'Start Time'"
                           type="time"
                           class="cell-input"
                           [formControlName]="field.label+'_'+timesheet.index"
                           min="06:00:00" max="20:00:00"
                           [ngClass]="{'invalidField': timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}" />

                    <input *ngIf="field.type === 'time_range' && field.label === 'End Time'"
                           type="time"
                           class="cell-input"
                           [formControlName]="field.label+'_'+timesheet.index"
                           min="06:00:00" max="20:00:00"
                           [ngClass]="{'invalidField': timesheetForm.controls[field.label+'_'+timesheet.index]?.errors && timesheetForm.controls[field.label+'_'+timesheet.index]?.touched}" />

                    <button type="button"
                            class="cell-copy"
                            title="Copy to following days"
                            (click)="copyValues(field.label, field.label+'_'+timesheet.index, timesheet.index)">
                      <i class="bi bi-files"></i>
                    </button>
                  </div>
                </ng-container>

                <div class="cell remove-cell">
                  <button type="button" class="remove-day" title="Remove day" (click)="removeSlide(i, timesheet.index)">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

        </form>

        <div class="ts-error" *ngIf="error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>{{error}}</span>
        </div>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="preview">
      <app-timesheet-details
        [fields]="fields"
        [jobName]="jobName"
        [clientName]="clientName"
        [end_date]="end_date"
        [start_date]="start_date"
        [from]="'create-timesheet'"
        [timesheetForm]="timesheetFormToPreview"
        [timesheetDetails]="timesheetDetailsToPreview"
      ></app-timesheet-details>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="modal-foot">
    <div class="left">
      <span class="total-chip" *ngIf="timesheets.length && !showTotalDays">
        Total: {{ totalHours }} hrs
      </span>
      <span class="total-chip" *ngIf="timesheets.length && showTotalDays">
        Total: {{ totalDays }} days
      </span>
      <span class="entries-hint" *ngIf="!timesheets.length">
        <i class="bi bi-info-circle"></i>
        <span>Pick an assignment and a date range to begin.</span>
      </span>
    </div>
    <div class="right">
      <button type="button"
              class="btn btn-secondary"
              [disabled]="loading || !timesheets.length"
              (click)="preview ? preview = false : previewTimesheet()">
        <i class="bi" [ngClass]="preview ? 'bi-arrow-left' : 'bi-eye'"></i>
        {{ preview ? 'Back' : 'Preview' }}
      </button>
      <button type="submit"
              class="btn btn-primary"
              [disabled]="loading || !timesheets.length"
              (click)="onSubmit()">
        <i class="bi bi-check-lg"></i>
        Submit
      </button>
    </div>
  </div>
</div>
